export default "__VITE_ASSET__DtxTfvr2__"